<template>
  <div class="document-layout container">
    <header class="document-layout__header">
      <figure class="document-layout__logo">
        <img
          class="document-layout__img"
          alt="Lily Plants"
          src="@/assets/logo_v2.svg"
          width="217"
          height="52"
        />
      </figure>
    </header>

    <main class="document-layout__content">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'DocumentLayout',

  metaInfo() {
    const title = this.$route.meta.title || 'Document';

    return {
      titleTemplate: `%s | ${title}`,
    };
  },
};
</script>

<style lang="scss">
.document-layout {
  $this: 'document-layout';

  &__header {
    padding-top: 20px;
    padding-bottom: 20px;

    @include media('sm') {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }

  &__logo {
    height: 52px;
    width: 217px;
    line-height: 0;
    margin: 0;
  }

  &__img {
    max-width: 100%;
    max-height: 100%;
  }

  &__content {
    line-height: 1.6;
    letter-spacing: 0.75px;
    color: $plant_description;
    padding-bottom: 20px;

    @include media('sm') {
      padding-top: 20px;
    }

    h1 {
      color: $plant_description;
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 24px;

      @include media('sm') {
        font-size: 40px;
        margin-bottom: 30px;
      }
    }

    section {
      margin-bottom: 25px;

      @include media('sm') {
        margin-bottom: 60px;
      }
    }

    h2 {
      color: $plant_description;
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 12px;

      @include media('sm') {
        font-size: 24px;
        margin-bottom: 25px;
      }
    }

    h3 {
      color: $plant_description;
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 20px;

      @include media('sm') {
        font-size: 18px;
      }
    }

    p,
    ul {
      font-size: 13px;
      margin-bottom: 20px;

      @include media('sm') {
        font-size: 15px;
      }
    }

    li {
      margin-bottom: 10px;
    }
  }
}

.alpha-list {
  counter-reset: list;
  list-style-type: none;

  li:before {
    content: counter(list, lower-alpha) ') ';
    counter-increment: list;
  }
}
</style>
